module.exports = __webpack_public_path__ + "static/media/amazonses-logo.597db012.png";